export const { isArray } = Array
export const toArray = (value: any): any[] => (isArray(value) ? value : [value])
export const isObject = (value: any): boolean => typeof value === 'object' && value !== null && !isArray(value)
